export default __webpack_public_path__ + "static/media/CNo.42-0.ed8e869b.jpg";